import { dvtSearchColumns, khachHangSearchColumns, ngoaiTeSearchColumns, vatTuSearchColumns } from '@/constants/';
import { DoiTuong, DonViTinh, NgoaiTe, VatTu } from '@/types/schemas';
import { SearchField, FormField } from '@/components/custom/erp';
import useVatTuDvtOptions from '../../hooks/useVatTuDvtOptions';
import { Label } from '@/components/ui/label';
import { QUERY_KEYS } from '@/constants';
import { FormMode } from '@/types/form';

interface SearchFields {
  vatTu: VatTu | null;
  setVatTu: (vatTu: VatTu | null) => void;
  donViTinh: DonViTinh | null;
  setDonViTinh: (donViTinh: DonViTinh | null) => void;
  nhaCungCap: DoiTuong | null;
  setNhaCungCap: (nhaCungCap: DoiTuong) => void;
  ngoaiTe: NgoaiTe | null;
  setNgoaiTe: (ngoaiTe: NgoaiTe) => void;
}

interface BasicInfoProps {
  formMode: FormMode;
  searchFields: SearchFields;
}

const BasicInfo = ({ formMode, searchFields }: BasicInfoProps) => {
  const { vatTu, setVatTu, donViTinh, setDonViTinh, nhaCungCap, setNhaCungCap, ngoaiTe, setNgoaiTe } = searchFields;
  const isViewMode = formMode === 'view';
  const { dvtOptions, handleVatTuSelection } = useVatTuDvtOptions({
    vatTu,
    setVatTu,
    donViTinh,
    setDonViTinh
  });

  return (
    <div className='max-h-[calc(100vh-150px)] space-y-2 overflow-y-auto p-4'>
      <div className='flex flex-col sm:flex-row sm:items-center'>
        <Label className='mt-2 min-w-40'>Mã vật tư</Label>
        <SearchField<VatTu>
          type='text'
          displayRelatedField='ten_vt'
          columnDisplay='ma_vt'
          searchEndpoint={`/${QUERY_KEYS.VAT_TU}/`}
          searchColumns={vatTuSearchColumns}
          dialogTitle='Danh mục vật tư'
          value={vatTu?.ma_vt || ''}
          relatedFieldValue={vatTu?.ten_vt || ''}
          onRowSelection={handleVatTuSelection}
          disabled={isViewMode}
          className='w-100'
        />
      </div>

      <div className='flex flex-col sm:flex-row sm:items-center'>
        <Label className='mt-2 min-w-40'>Đơn vị tính</Label>
        <SearchField<DonViTinh>
          type='text'
          displayRelatedField='ten_dvt'
          columnDisplay='dvt'
          rows={dvtOptions}
          searchEndpoint={dvtOptions.length > 0 ? undefined : `/${QUERY_KEYS.DON_VI_TINH}/`}
          relatedFieldValue={donViTinh?.ten_dvt || ''}
          searchColumns={dvtSearchColumns}
          dialogTitle='Danh mục đơn vị tính'
          value={donViTinh?.dvt || ''}
          onRowSelection={setDonViTinh}
          disabled={isViewMode}
          className='w-100'
        />
      </div>

      <div className='flex flex-col sm:flex-row sm:items-center'>
        <Label className='mt-2 min-w-40'>Ngày hiệu lực</Label>
        <FormField type='date' name='ngay_hl' className='w-48' disabled={isViewMode} />
      </div>

      <div className='flex flex-col sm:flex-row sm:items-center'>
        <Label className='mt-2 min-w-40'>Nhà cung cấp</Label>
        <SearchField<DoiTuong>
          type='text'
          displayRelatedField='customer_name'
          columnDisplay='customer_code'
          searchEndpoint={`/${QUERY_KEYS.NHA_CUNG_CAP}/`}
          searchColumns={khachHangSearchColumns}
          dialogTitle='Danh mục nhà cung cấp'
          value={nhaCungCap?.customer_code || ''}
          onRowSelection={setNhaCungCap}
          disabled={isViewMode}
          className='w-100'
        />
      </div>

      <div className='flex flex-col sm:flex-row sm:items-center'>
        <Label className='mt-2 min-w-40'>Ngoại tệ</Label>
        <SearchField<NgoaiTe>
          type='text'
          displayRelatedField='ten_nt'
          columnDisplay='ma_nt'
          searchEndpoint={`/${QUERY_KEYS.NGOAI_TE}/`}
          searchColumns={ngoaiTeSearchColumns}
          dialogTitle='Danh mục ngoại tệ'
          value={ngoaiTe?.ma_nt || ''}
          onRowSelection={setNgoaiTe}
          disabled={isViewMode}
          className='w-100'
        />
      </div>

      <div className='flex flex-col sm:flex-row sm:items-center'>
        <Label className='mt-2 min-w-40'>Số lượng từ</Label>
        <FormField type='number' name='sl_tu' className='w-48' disabled={isViewMode} />
      </div>

      <div className='flex flex-col sm:flex-row sm:items-center'>
        <Label className='mt-2 min-w-40'>Giá mua</Label>
        <FormField type='number' name='gia_nt' className='w-48' disabled={isViewMode} />
      </div>

      <div className='flex flex-col sm:flex-row sm:items-center'>
        <Label htmlFor='status' className='mt-2 min-w-40'>
          Trạng thái
        </Label>
        <FormField
          id='status'
          type='select'
          name='status'
          className='w-48'
          options={[
            { label: '1. Còn sử dụng', value: 1 },
            { label: '0. Không sử dụng', value: 0 }
          ]}
          disabled={isViewMode}
        />
      </div>
    </div>
  );
};

export default BasicInfo;
